import { Box, Modal, Grid } from "@mui/material";
import React, {useState} from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

interface CompanyModalProps {
  open: string;
  isEdit?: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  company?: any;
  setCompany?: any;
  loading?: boolean;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 800,
  width: "100%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  borderRadius: "10px",
};

const CompanyModal = ({
  open = "",
  onClose,
  isEdit = false,
  onSubmit,
  company,
  setCompany,
  loading = false,
}: CompanyModalProps) => {
  const changeHandler = (e: any) => {
    const name = e?.target?.name;
    const value = e?.target?.value;
    const regPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\./0-9]*$/;
    if (name === "phone") {
      if (value && regPhone.test(value)) {
        setCompany((pre: any) => ({
          ...pre,
          [name]: value,
        }));
      }
    } else {
      setCompany((pre: any) => ({
        ...pre,
        [name]: value,
      }));
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <Modal open={open.length > 0} onClose={onClose}>
      <Box sx={style}>
        <div className={"text-2xl font-bold"}>
          {open} Company
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (onSubmit) {
              onSubmit();
            }
          }}
          className={"flex flex-col gap-4"}
        >
          <Grid container spacing={2} className={"overflow-auto max-h-[600px]"}>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"name"} className={"text-sm font-semibold"}>
                  Name
                </label>
                <input
                  id={"name"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"name"}
                  value={company?.name}
                  onChange={changeHandler}
                  required={!isEdit}
                  readOnly={loading}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"domain"} className={"text-sm font-semibold"}>
                  Domain
                </label>
                <input
                  id={"domain"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"domain"}
                  value={company?.domain}
                  onChange={changeHandler}
                  readOnly={loading}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"contact_email"}
                  className={"text-sm font-semibold"}
                >
                  Email
                </label>
                <input
                  id={"contact_email"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  name={"contact_email"}
                  value={company?.contact_email}
                  onChange={changeHandler}
                  type={"text"}
                  required
                  readOnly={loading}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"phone"} className={"text-sm font-semibold"}>
                  Phone
                </label>
                <input
                  id={"phone"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"phone"}
                  value={company?.phone}
                  onChange={changeHandler}
                  required
                  readOnly={loading}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className="w-full flex flex-col items-start relative">
                <label htmlFor="password" className="text-sm font-semibold">
                  Password
                </label>
                <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={company?.password}
                    onChange={changeHandler}
                    readOnly={loading}
                    required={open === 'Create'}
                    className="bg-white w-full rounded-md p-2 border border-gray outline-none pr-8"
                />
                <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-2 top-8 text-gray-600"
                >
                  {showPassword ? <AiFillEye size={20} /> : <AiFillEyeInvisible size={20} />}
                </button>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"address"} className={"text-sm font-semibold"}>
                  Address
                </label>
                <input
                  id={"address"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  name={"address"}
                  value={company?.address}
                  onChange={changeHandler}
                  type={"text"}
                  required
                  readOnly={loading}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"latitude"} className={"text-sm font-semibold"}>
                  Latitude
                </label>
                <input
                  id={"latitude"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  name={"latitude"}
                  value={company?.latitude}
                  onChange={changeHandler}
                  type={"number"}
                  required
                  readOnly={loading}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"longitude"}
                  className={"text-sm font-semibold"}
                >
                  Longitude
                </label>
                <input
                  id={"longitude"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  name={"longitude"}
                  value={company?.longitude}
                  onChange={changeHandler}
                  type={"number"}
                  required
                  readOnly={loading}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"number_of_current_employee"}
                  className={"text-sm font-semibold"}
                >
                  Number of current employee
                </label>
                <input
                  id={"number_of_current_employee"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  name={"number_of_current_employee"}
                  value={company?.number_of_current_employee}
                  onChange={changeHandler}
                  type={"number"}
                  required
                />
              </div>
            </Grid>
          </Grid>
          <button
            className={
              "bg-primary flex justify-center items-center text-white p-3 rounded-2xl disabled:cursor-not-allowed disabled:opacity-70 opacity-100 w-full"
            }
            type={"submit"}
            disabled={loading}
          >
            {loading ? (
              <AiOutlineLoading3Quarters className={"animate-spin"} />
            ) : (
              `${open} Company`
            )}
          </button>
        </form>
      </Box>
    </Modal>
  );
};
export default CompanyModal;
